<template>
    <div>
        <list v-if="!public_id" v-model="entity" :list="list" selected="paypal" :usekey="true"></list>
        <component v-bind:is="entity"></component>
    </div>
</template>
<script>
    export default {
        data: function() {
            return {
                uid: this.uniqueid(),
                public_id: 0,
                entity: 'paypal',
                list: {
                    paypal: 'PayPal Express',
                    eway: 'eWay',
                    stripe: 'Stripe',
                    bank: 'Bank Transfer',
                    quickapay: 'QuickaPay'
                }
            }
        },
        components: {
            'list': require('../../components/form/list.vue').default,
            'paypal': require('./types/paypal.vue').default,
            'eway': require('./types/eway.vue').default,
            'stripe': require('./types/stripe.vue').default,
            'bank': require('./types/bank-transfer.vue').default,
            'quickapay': require('./types/quickapay.vue').default
        },
        created(){
            this.$eventHub.$on('setPaymentGateways', this.setData);
        },
        methods: {
            setData(data) {
                let entity = data.gateway_id;
                switch (entity) {
                    case 'BankTransfer':
                        entity = 'bank';
                        break;
                    case 'PayPal_Express':
                        entity = 'paypal';
                        break;
                    case 'Eway_Rapid':
                        entity = 'eway';
                        break;
                    case 'QuickaPay':
                        entity = 'quickapay';
                        break;
                }
                this.entity = entity;
                this.public_id = data.public_id;
                this.$nextTick(() => {
                    if (typeof this.$children[0] !== 'undefined' && this.$children[0].setData !== 'undefined') {
                        this.$children[0].setData(data);
                    }
                });
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('setPaymentGateways', this.setData);
        }
    }
</script>
